import axios, {AxiosResponse} from 'axios';
import { ProcessesVM } from '../Models/ViewModels';
const api_url = process.env.REACT_APP_STEM_API_BASE_URL+'/api'

const headers = { 
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  } 


  export const GetProcessDetails=()=>{
    return axios.get(api_url+'/ProcessMaster/GetProcessDetails');
}
export const GetActionDetails=()=>{
   return axios.get(api_url+'/SubStateMaster/GetActionDetails');
}
export const GetPayerDetails=()=>{
   return axios.get(api_url+'/SubStateMaster/GetPayerDetails');
}


export const EditProcess = (editprr:ProcessesVM,loginId:any) =>
   {
      const payload = { "ProcessID" :  editprr.ProcessID,"ProcessName":editprr.ProcessName,
      "ProcessCode":editprr.ProcessCode,
      "ModifiedBy":loginId
   }
   
     return axios.post(api_url+'/ProcessMaster/EditProcess',payload,{headers})
     
   }

export const AddProcess = (Addprr:ProcessesVM,loginId:any) =>
   {
      const payload = { "ProcessName":Addprr.ProcessName,
      "ProcessCode":Addprr.ProcessCode,
      "CreatedBy":loginId
   }
   
     return axios.post(api_url+'/ProcessMaster/AddProcess',payload,{headers})
     
   }

export const DeleteProcess=(ProcessID:number)=>{
    return axios.post(api_url+'/ProcessMaster/DeleteProcess?processId='+ ProcessID)
}